import { render, staticRenderFns } from "./UserAssigned.vue?vue&type=template&id=15538d1c"
import script from "./UserAssigned.vue?vue&type=script&lang=js"
export * from "./UserAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports